import nodeStates from '../constants/nodeStates';
import nodeDescriptions from '../constants/nodeDescriptions';
import nodeLabelCases from '../constants/nodeLabelCases';

function getNodeDescriptionIssue(node) {
    if (!Object.values(nodeDescriptions).includes(node.description)) {
        return {
            type: 'invalidDescription',
            value: node.description,
        };
    }

    return null;
}

function getNodeStateIssue(node) {
    if (!Object.values(nodeStates).includes(node.state)) {
        return {
            type: 'invalidState',
            value: node.state,
        };
    }

    return null;
}

function nodeMatchesLabelCase(node, labelCase) {
    return (
        labelCase.nodeTypes.includes(node.description) &&
        labelCase.state === node.state
    );
}

function buildLabelCaseIssues(node) {
    const labelCase = nodeLabelCases.find((x) => nodeMatchesLabelCase(node, x));
    if (!labelCase) {
        return {
            type: 'InvalidLabelCase',
            value: `state:${node.state}, description:${node.description}`,
        };
    }
    return null;
}

function decorateNodeIssues(node) {
    const issues = [];

    const stateIssue = getNodeStateIssue(node);
    if (stateIssue) {
        issues.push(stateIssue);
    }

    const descriptionIssue = getNodeDescriptionIssue(node);
    if (descriptionIssue) {
        issues.push(descriptionIssue);
    }

    if (descriptionIssue || stateIssue) {
        return { ...node, issues };
    }

    const invalidLabelCaseIssue = buildLabelCaseIssues(node);
    if (invalidLabelCaseIssue) {
        issues.push(invalidLabelCaseIssue);
    }
    return { ...node, issues };
}

export default function buildNodesThatAreNotWhatWeExpectForTheTimeline(nodes) {
    return nodes.map(decorateNodeIssues).filter((x) => x.issues.length > 0);
}
